"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SparseMatrixDependencies = void 0;
var _dependenciesMatrixClassGenerated = require("./dependenciesMatrixClass.generated.js");
var _dependenciesEqualScalarGenerated = require("./dependenciesEqualScalar.generated.js");
var _dependenciesTypedGenerated = require("./dependenciesTyped.generated.js");
var _factoriesAny = require("../../factoriesAny.js");
/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */

var SparseMatrixDependencies = exports.SparseMatrixDependencies = {
  MatrixDependencies: _dependenciesMatrixClassGenerated.MatrixDependencies,
  equalScalarDependencies: _dependenciesEqualScalarGenerated.equalScalarDependencies,
  typedDependencies: _dependenciesTypedGenerated.typedDependencies,
  createSparseMatrixClass: _factoriesAny.createSparseMatrixClass
};